import { render, staticRenderFns } from "./TextareaForm.vue?vue&type=template&id=daef85f4&scoped=true&"
import script from "./TextareaForm.vue?vue&type=script&lang=js&"
export * from "./TextareaForm.vue?vue&type=script&lang=js&"
import style0 from "./TextareaForm.vue?vue&type=style&index=0&id=daef85f4&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "daef85f4",
  null
  
)

export default component.exports